
import { useState } from 'react'
import Swal from 'sweetalert2'
import { getArray } from '../../../../helpers/fetch'

import { useForm } from "../../../../hooks/useForm"
import { Search } from '../../../ui/Search'
import { Select } from '../../../ui/Select'
import { ProductCardStock } from './ProductCardStock'
import { ProductsModal } from './ProductsModal'
import { ProductUndefinedScreen } from './ProductUndefinedScreen'
import { Spin } from './Spin'



export const ProductAddScreen = () => {

 



  const [isLoading, setIsLoading] = useState(false)
  const actualData = JSON.parse( localStorage.getItem("dataInStorage"))
  
  const [data, setdata] = useState( actualData ? JSON.parse( localStorage.getItem("dataInStorage")):[])

  const [search, setSearch] = useState('')
  const [currentSelected, setcurrentSelected] = useState('')
 

  const [ formaValues, handleInputChange ] = useForm({
    accountFetch:''
  });
  
  const { accountFetch  } = formaValues


// console.log(data)
  let dataSelected 

  if( currentSelected !== 'all'){

     dataSelected =  data.filter( itemFiltrado => itemFiltrado.type.toUpperCase().includes( currentSelected.toUpperCase() ) )
      
    }else{
      dataSelected = data
  }

  const dataFiltered = dataSelected.filter( itemFiltrado => itemFiltrado.nombre.toUpperCase().includes( search.toUpperCase() ) )

  const handleReset = async(e) =>{
    e.preventDefault()
    await localStorage.setItem('dataInStorage',JSON.stringify([]))
    await setdata( JSON.parse( localStorage.getItem("dataInStorage")) )
  }

  const handleFetch = async(e) =>{
    e.preventDefault()

    if(accountFetch !== ''){
      //carga spin
    setIsLoading(true)

    // busca una cuenta steam
     await getArray(accountFetch).then(Array => 
      {if(Array === "2"){
            //  2 = usuario de steam que no existe
            
              Swal.fire({
              title: 'El usuario de steam no existe o esta mal escrito el URL',
              html:
              'Puedes usar por ejemplo: ' +
              'https://steamcommunity.com/id/<b>TUIDSteam</b> </br>' +
              'id/<b>TUIDSteam</b> ' +
              '<p><b>TUIDSteam</b></p> ',

              showClass: {
                popup: 'animate__animated animate__fadeInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
              }
            }) 
            return localStorage.setItem( "dataInStorage", JSON.stringify([]) )

          }else if(Array === "1"){
            // 1 = Inventario privado
            
            Swal.fire({
            title: 'El inventario esta privado',

            showClass: {
              popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp'
            }
          }) 
          return localStorage.setItem( "dataInStorage", JSON.stringify([]) )

        }else if(Array.length > 3){

          


          localStorage.setItem( "dataInStorage", JSON.stringify(Array) )
        
        }}
      )
    
      // modifica la data con lo que este establecido en el localStorage
      // array vacio para valor 1 y 2, array con objetos su paso las pruebas
     await setdata( JSON.parse( localStorage.getItem("dataInStorage")) )
    

     //fin del spin
     setIsLoading(false)

    }else{
        Swal.fire({
            title: 'Debe ingresar un URL valido',
            html:
                'Puedes usar por ejemplo: ' +
                'https://steamcommunity.com/id/<b>TUIDSteam</b> </br>' +
                'id/<b>TUIDSteam</b> ' +
                '<p><b>TUIDSteam</b></p> ',
            showClass: {
              popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp'
            }
          })
    }
    
}



if(isLoading){
  return (
    <div className='spin'>
      <Spin />

    </div>
  )
}

  return (
    <div className="row _products">
      <h5 className="col-2 title-panel ">Agregar Productos</h5>
     
     {/* CUANDO NO HAY CUENTA MATCHEADA */}
      {(data.length < 1) ?
      
        <form 
            onSubmit={handleFetch}
            className="col-3 formSerchSteam"
        >
            <input 
                type="search" 
                className="search col-10"
                placeholder="Inserte URL de su perfil steam "
                name="accountFetch"
                value={accountFetch}
                onChange={ handleInputChange }
            ></input>
            
            <button className='btn-search'><i className="fa-solid fa-circle-right"></i></button>
        </form> 
  
        :
    //CUENTA        
        <div className="_accMenu col-10 row ">

          <div className="col-3">
            <span>Cuenta: </span> <a  href={`https://steamcommunity.com/id/${data[0].acc}/inventory/`} target="_blank" rel="noreferrer" className='cuenta'> {data[0].acc} </a>
            <i className="fa-solid fa-square-xmark close" onClick={handleReset}></i> 
          </div>

          <div className='col-3'>
            <Search search={ search } setSearch={ setSearch }  setcurrentSelected={setcurrentSelected}/>
          </div>

          <div className=' col-3'>
            <Select currentSelected={ currentSelected }  setcurrentSelected={ setcurrentSelected } />
          </div>

        </div>
      }


      <div className="_productCardStock row add">

          {(dataFiltered.length >= 1)
          
          ?
          
          dataFiltered.map(producto =>
          
            <ProductCardStock item={producto}  key={producto.inspect} />
            
            )
            :
            (data.length > 1)&&
            <ProductUndefinedScreen />
            
            
          }
      

      </div>
     
      <ProductsModal />
    </div>
  )
}
